var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHello(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hello_svg__clip0_2637_47825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 30.5c0 10.52-6.372 19.554-15.468 23.45-1.089.467-2.218-3.38-3.38-3.067-.683.184-1.38 4.581-2.086 4.709-.619.112-1.246.202-1.88.268-.882.093-1.779-8.157-2.686-8.157-12.425 0-16.494-2.245-25.04-12.355-.302-1.57-.46-3.19-.46-4.848C3 16.417 14.417 5 28.5 5S54 16.417 54 30.5z",
    fill: "#88D5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.11 27.422l9.013-.221s.284-1.95.618-4.799c-2.897.32-5.821.544-8.755.667-.554 2.606-.877 4.353-.877 4.353z",
    fill: "#FF696A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.101.316c-.806-.062-1.668 1.082-2.525 2.922 1.353.093 2.703.176 4.052.252C36.387 1.6 35.917.38 35.1.316z",
    fill: "#D379FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.625 3.493a225.72 225.72 0 01-4.053-.253c-.59 1.263-1.175 2.86-1.739 4.624 1.999-.11 3.995-.217 5.997-.325.003-1.521-.06-2.906-.205-4.046z",
    fill: "#79D5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.832 7.54c-1.999.11-3.995.217-5.997.325-.471 1.469-.93 3.055-1.364 4.669 2.394-.039 4.79-.061 7.186-.078a81.39 81.39 0 00.175-4.916z",
    fill: "#96FD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.044 18.275a268.276 268.276 0 00-1.064 4.795c2.94-.123 5.858-.347 8.756-.666.18-1.527.373-3.309.547-5.19-2.766.25-5.517.606-8.24 1.061z",
    fill: "#FF9F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.289 17.213c.146-1.549.273-3.162.37-4.752-2.395.014-4.797.037-7.187.078-.516 1.93-.997 3.896-1.427 5.742 2.721-.461 5.472-.817 8.244-1.068z",
    fill: "#FFB531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.855 23.356a3.453 3.453 0 100-6.906 3.453 3.453 0 000 6.906z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.392 21.917a2.014 2.014 0 100-4.028 2.014 2.014 0 000 4.028z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.646 10.005a3.776 3.776 0 00-3.776 3.776v4.571h7.552v-4.571a3.776 3.776 0 00-3.776-3.776z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.773 10.175a3.78 3.78 0 00-2.65 3.606v4.571H22.87v-4.571a3.776 3.776 0 014.903-3.606z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.648 10.767a5.286 5.286 0 010 10.571V10.767z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.544 23.387H24.46a7.282 7.282 0 01-6.395 7.797 7.285 7.285 0 01-4.873 8.44 8.443 8.443 0 01.957 3.915c0 2.374 1.759 1.818.188 3.357-.86-.761-1.582-.568-2.332-1.438-.51-.592-3.816.482-4.273-.157a25.359 25.359 0 01-4.272-9.953 7.49 7.49 0 01.639-.146 7.282 7.282 0 015.978-9.733 7.282 7.282 0 017.124-8.798h9.171a3.17 3.17 0 013.17 3.17v3.546z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.986 23.954c0 .52.056 1.026.16 1.515a7.283 7.283 0 00-5.978 9.733 8.478 8.478 0 00-4.995 2.96 24.955 24.955 0 01-.712-2.814c.21-.058.423-.106.639-.146a7.282 7.282 0 015.978-9.733 7.282 7.282 0 017.124-8.798h5.067a7.283 7.283 0 00-7.283 7.283z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 20.3H20.535v10.008a9.237 9.237 0 0017.508 4.113h7.304a2.91 2.91 0 004.465.417 2.908 2.908 0 00.853-2.061v-9.233a3.244 3.244 0 00-3.243-3.243z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.186 35.284V55.86A25.74 25.74 0 0128.5 56c-7.72 0-14.64-3.431-19.315-8.852L20.536 20.3l10.65 14.983z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.69 34.372l-8.451 17.27a25.675 25.675 0 01-6.506-6.341l12.803-25 1.84 2.59.314 11.48z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.422 20.3a6.076 6.076 0 0012.151 0H9.422z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.89 25.249a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM49.071 25.249a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2z",
    fill: "#DA387D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.078 39.453a9.237 9.237 0 01-10.543-9.145V20.3h2.606v10.006c0 4.66 3.452 8.514 7.937 9.146z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.938 23.356a3.453 3.453 0 100-6.906 3.453 3.453 0 000 6.906z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.027 21.917a2.014 2.014 0 100-4.028 2.014 2.014 0 000 4.028z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.19 32.005a3.882 3.882 0 01-3.878-3.878.996.996 0 011.992 0c0 1.04.846 1.886 1.886 1.886s1.885-.846 1.885-1.886a.996.996 0 011.992 0 3.882 3.882 0 01-3.877 3.878z",
    fill: "#DA387D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.938 27.898a3.453 3.453 0 100-6.907 3.453 3.453 0 000 6.907z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.58 5.035a.967.967 0 00-.675 1.19l2.622 9.484a.967.967 0 101.865-.516L15.77 5.71a.967.967 0 00-1.19-.675zM10.272 7.236a.967.967 0 00-.674 1.19l1.008 3.646-4.698 1.299L4.9 9.724a.967.967 0 00-1.865.516l2.622 9.483a.967.967 0 001.865-.516l-1.098-3.971 4.697-1.299 1.098 3.972a.967.967 0 001.865-.516L11.463 7.91a.968.968 0 00-1.19-.674zM50.582 11.774a.679.679 0 00-.926.253l-3.423 5.995a.679.679 0 001.179.673l3.423-5.995a.679.679 0 00-.253-.926zM47.356 10.718a.68.68 0 00-.926.253l-1.316 2.306-2.97-1.696 1.316-2.305a.679.679 0 00-1.18-.673l-3.422 5.995a.68.68 0 001.18.673l1.433-2.51 2.97 1.695-1.434 2.51a.679.679 0 101.18.674l3.422-5.995a.679.679 0 00-.253-.927z",
    fill: "#10239E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.575 42.138h-3.552a.957.957 0 00-.957.957v3.018l2.484 2.584 2.982-2.584v-3.018a.957.957 0 00-.957-.957z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.532 46.113v7.837a25.26 25.26 0 01-5.466 1.642v-9.48h5.466z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.153 46.113v9.01c-.684.185-1.38.341-2.087.469v-9.48h2.087z",
    fill: "#ECF1F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hello_svg__clip0_2637_47825"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/hello.035033f34a090eb0cd5aee1e58b4e8b0.svg";
export { SvgHello as ReactComponent };